import IMask from 'imask';


(function() {
    Array.from(document.getElementsByClassName('mac-address')).forEach((el) => {
        IMask(el,{
                mask: [
                    {
                        mask: '##.##.##.##',
                        definitions: {
                            '#': /^[a-z0-9]+$/i
                        },
                    },
                    {
                        mask: '## ## ## ## ## ## ##',
                        definitions: {
                            '#': /^[a-z0-9]+$/i
                        },
                    }
                ],
                lazy: false,
            });
    });

})();
